<template>
  <div class="d-flex justify-center">
    <v-sheet color="white" elevation="5" rounded class="mt-5 mb-5 pt-5 pb-5 pl-5 pr-5">
      <v-overlay :value="isLoading">
        <v-progress-circular 
          indeterminate
          color="primary"
          :size="70"
          :width="7"
        />
      </v-overlay>
      <div v-if="!isLoading">
        <div v-if="!!errorMessage">
          {{errorMessage}}
        </div>
        <div v-else-if="!foundRequest">
          Signature request not found.
        </div>
        <div v-else>
          <v-alert type="warning" class="my-3" v-if="requiresActiveMembership && (registerMember || renewMember)">
              <p v-if="registerMember">
                You need to become a member in order to proceed, you can register <router-link to="/registration/member">here.</router-link>.
              </p>
              <p v-else>You're not an active member at the moment please renew <router-link to="/renew/member">here</router-link> to proceed.</p>
          </v-alert>
          <h4 class="d-flex justify-space-between">
            <slot name="subtitle" />
            <span>Submitted on {{submittedAt ? $dateUtils.formatDateTime(submittedAt) : ""}}</span>
          </h4>   
          <h1 class="blue--text text--darken-2 d-flex justify-start mt-5">
            <slot name="title" />
          </h1>
          <slot name="approvedContent" />    
          <div class="mt-3" >
            <slot name="legalText" />
            <v-text-field
              outlined
              v-model="signatureText"
              label="Signature"
            />
          </div>
          <v-row class="ma-0">
            <v-spacer />
            <v-btn                    
              large
              v-on:click="sign"
              :disabled="!signatureText || (requiresActiveMembership && (registerMember || renewMember))"
              color="primary"
              class="white--text"
              width="125px">
              Sign
            </v-btn>
          </v-row>
        </div>
      </div>
    </v-sheet>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Signature from "@/components/common/inputs/Signature.vue";
import { UserInfo } from "@/types/User";

export default Vue.extend({
  name: 'SignatureLayout',
  components: { Signature },
  props: {
    signatureId: Number,
    workflowGuid: String,
    submitSignature: Function,
    foundRequest: Boolean,
    isLoading: Boolean,
    submittedAt: String,
    errorMessage: String,
    requiresActiveMembership: Boolean,
  },
  data: function() {
    return {
      signatureText: ""
    };
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    registerMember(): boolean {
      return this.userInfo.hasNeverBeenMember;
    },
    renewMember(): boolean {
      return !this.userInfo.isActiveMember;
    },
  },
  methods: {
    sign: function() {
      this.submitSignature(
        this.workflowGuid,
        this.signatureId,
        this.userInfo.personId,
        this.$data.signatureText
      );

      this.$store.dispatch("loadPersonTasks", this.userInfo.personId);
    },
  },
});
</script>
